export default {
    PleaseEnterSupplierName: "ကျေးဇူးပြု၍ ဆိုင်အမည်ထည့်ပါ။",
    pleaseSelectMainBusinessCategory: "ကျေးဇူးပြု၍ ပင်မလုပ်ငန်းအမျိုးအစားကို ရွေးချယ်ပါ။",
    pleaseEnterContactName: "ကျေးဇူးပြု၍ ဆက်သွယ်ရန်အမည်ကို ထည့်သွင်းပါ။",
    pleaseEnterContactPhoneNumber: "ကျေးဇူးပြု၍ ဆက်သွယ်ရန်ဖုန်းနံပါတ်ကို ထည့်ပါ။",
    pleaseEnterDetailedAddress: "ကျေးဇူးပြု၍ အသေးစိတ်လိပ်စာထည့်ပါ။",
    pleaseSetYourPassword: "Password သတ်မှတ်ပေးပါ။",
    pleaseConfirmPassword: "ကျေးဇူးပြု၍ စကားဝှက်ကို အတည်ပြုပါ။",
    NeedProvideBusinessLicense: "(ကျေးဇူးပြု၍ လုပ်ငန်းလိုင်စင်ပေးပါ)",
    pleaseEnterTheNameOfLegalPerson: "ကျေးဇူးပြု၍ တရားဝင်ပုဂ္ဂိုလ်၏အမည်ကို ထည့်သွင်းပါ။",
    pleaseEnterThePhoneNumber: "ကျေးဇူးပြု၍ ဖုန်းနံပါတ်ထည့်ပါ။",
    pleaseEnterLegalPersonsIDCard: "ကျေးဇူးပြု၍ တရားဝင်ပုဂ္ဂိုလ်များ၏ ID ကတ်ကို ထည့်သွင်းပါ။",
    pleaseEnterUnifiedSocialCreditCode: "ကျေးဇူးပြု၍ Unified Social Credit Code ကိုထည့်ပါ။",
    pleaseSelectDate: "ရက်စွဲကို ရွေးပါ။",
    MustContainCombinationUppercaseNLowercaseLettersNNumbers: "၎င်းတွင် စာလုံးအကြီးနှင့် အသေးစာလုံးများနှင့် နံပါတ်များပါရှိရမည်၊ အရှည်မှာ 6 နှင့် 20 ကြားဖြစ်ပြီး အထူးအက္ခရာများကို အသုံးမပြုနိုင်ပါ။",
    pleaseEnterTheAdminsPhoneNumber: "ကျေးဇူးပြု၍ Admins ဖုန်းနံပါတ်ကို ထည့်ပါ။",
    threeToThirtyCharactersInLength: "အလျားအက္ခရာသုံးလုံးမှသုံးဆယ်",
    pleaseEnterTheNameOfTheAdmin: "ကျေးဇူးပြု၍ စီမံခန့်ခွဲသူအမည်ကို ထည့်ပါ။",
    pleaseEnterThePassword: "ကျေးဇူးပြု၍ Password ကိုထည့်ပါ။",
    pleaseEnterAccAndPsw: "ကျေးဇူးပြု၍ သင့်အကောင့်နံပါတ်နှင့် စကားဝှက်ကို ထည့်ပါ။",
    pleaseEnterPasswordAgain: "ကျေးဇူးပြု၍ စကားဝှက်ကို ထပ်မံထည့်သွင်းပါ။",
    theTwoPasswordsRInconsistent: "စကားဝှက်နှစ်ခု မကိုက်ညီပါ။",
    pleaseEnterTheWarehouseAddress: "ကျေးဇူးပြု၍ ဂိုဒေါင်လိပ်စာကို ထည့်ပါ။",
    pleaseEnterTheLegalPersonPhoneNumber: "ကျေးဇူးပြု၍ တရားဝင်ပုဂ္ဂိုလ်ဖုန်းနံပါတ်ကို ထည့်ပါ။",
    pleaseEnterTheLegalPersonIDNumber: "ကျေးဇူးပြု၍ တရားဝင်ပုဂ္ဂိုလ် ID နံပါတ်ကို ထည့်ပါ။",
    pleaseUploadBusinessLicense: "လုပ်ငန်းလိုင်စင်ကို ကျေးဇူးပြု၍ တင်ပါ။",
    pleaseUploadID: "ID တင်ပါ။",
    pleaseFillInTheBusinessPeriod: "လုပ်ငန်းကာလကို ကျေးဇူးပြု၍ ဖြည့်စွက်ပါ။",
    pleaseFillTheUnifiedScialCreditCode: "ကျေးဇူးပြု၍ Unified Scial Credit Code ကိုဖြည့်ပါ။"
}